// Do not change the order of MembershipLevel enum

export enum MembershipLevel {
  COT = 'Court of the Table',
  MDRT = 'MDRT',
  TOT = 'Top of the Table',
}
